import type { IUsageFeeBill } from '../types';

import { create } from 'zustand';

export interface IBillingStoreState {
  cappedAmount?: number;
  retryPaymentLoading: boolean;
  retryPaymentSuccess: {
    isSuccess: boolean;
    usageFeeBills?: IUsageFeeBill[];
  };
}

export interface IBillingStoreActions {
  setCappedAmount: (value: number) => void;
  setRetryPaymentSuccess: (isSuccess: boolean, usageFeeBills?: IUsageFeeBill[]) => void;
  setRetryPaymentLoading: (loading: boolean) => void;
}

export const useBillingStore = create<IBillingStoreState & IBillingStoreActions>()((set) => ({
  cappedAmount: undefined,
  retryPaymentLoading: false,
  retryPaymentSuccess: {
    isSuccess: false,
    usageFeeBills: [],
  },
  setRetryPaymentLoading: (loading: boolean) => {
    set(() => ({ retryPaymentLoading: loading }));
  },
  setCappedAmount: (val: number) => {
    set(() => ({ cappedAmount: val }));
  },
  setRetryPaymentSuccess: (isSuccess: boolean, usageFeeBills?: IUsageFeeBill[]) => {
    set(() => ({
      retryPaymentSuccess: {
        isSuccess,
        usageFeeBills,
      },
    }));
  },
}));
